import { FilterInputTypes, IFilterInput } from '../../../../shared/interfaces/filter-input.interface';

export const filterInputs: IFilterInput[] = [
  {
    resultLabel: 'Status',
    type: FilterInputTypes._dropdown,
    placeholder: 'Filter By Status',
    controlName: 'status',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
  },
  {
    resultLabel: 'From Date',
    type: FilterInputTypes._date,
    controlName: 'fromDate',
    placeholder: 'From Date',
  },
  {
    resultLabel: 'To Date',
    type: FilterInputTypes._date,
    controlName: 'toDate',
    placeholder: 'To Date',
  },
];
